import { render, staticRenderFns } from "./WhiteListRemoved.vue?vue&type=template&id=12ccad7e&scoped=true"
import script from "./WhiteListRemoved.vue?vue&type=script&lang=js"
export * from "./WhiteListRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ccad7e",
  null
  
)

export default component.exports